import { render, staticRenderFns } from "./JudgesEditComponent.vue?vue&type=template&id=31ecc21c"
import script from "./JudgesEditComponent.vue?vue&type=script&lang=js"
export * from "./JudgesEditComponent.vue?vue&type=script&lang=js"
import style0 from "./JudgesEditComponent.vue?vue&type=style&index=0&id=31ecc21c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports